import { cn } from '~/style';

export const Logo = ({ className }: { className?: string }) => {
  return (
    <div
      className={cn(
        'block w-10 select-none bg-black/60 backdrop-blur-md md:w-12 lg:w-14 xl:w-16',
        className,
      )}
    >
      <svg
        className="text-foreground"
        viewBox="0 0 74 74"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="2.5"
          y="2.5"
          width="69"
          height="69"
          fill="black"
          stroke="currentColor"
          strokeWidth="5"
        />
        <path
          d="M32.8935 46.9483L44.9337 27H52.8145L56.7001 46.9483H50.0233L49.5308 43.5552H41.4037L39.543 46.9483H32.8935ZM44.0306 38.9307H48.8467L48.2447 34.1693L47.9437 32.0623H47.7521L46.6302 34.1146L44.0306 38.9307Z"
          fill="currentColor"
        />
        <path
          d="M17 46.9483L21.132 27H37.5777L36.5652 31.8981H26.3585L25.647 35.2913H34.8139L33.8288 39.9158H24.6619L23.2116 46.9483H17Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
};
